import React, { useEffect, useCallback } from 'react'
import queryString from 'query-string'
import cookies from 'browser-cookies'
import LoadingText from 'shared/ui/LoadingText'
import usePromise from 'shared/hooks/usePromise'
import api from '../../utils/api'

export default function FetchingWorkshopData({ send, workshop }) {
  const getWorkshopPricing = useCallback(() => {
    return api.getWorkshop(workshop.id, {
      affiliateCode: cookies.get('reacttraining.affiliate'),
      promo: queryString.parse(window.location.search).promo,
    })
  }, [workshop.id])
  const { response, error, loading } = usePromise(getWorkshopPricing)

  useEffect(() => {
    if (error || (!loading && !response.id)) send({ type: 'ERROR', payload: error })
    else if (response && response.live !== true) send({ type: 'NOT_LIVE', payload: response })
    else if (response && response.seatsAvailable === 0)
      send({ type: 'SOLD_OUT', payload: response })
    else if (response) send({ type: 'SUCCESS', payload: { ...response } })
  }, [response])

  return <LoadingText>Fetching Ticket Data</LoadingText>
}
